import {provideHttpClient, withInterceptors} from '@angular/common/http'
import {ApplicationConfig, inject, LOCALE_ID, provideAppInitializer} from '@angular/core'
import {MAT_LUXON_DATE_ADAPTER_OPTIONS, MAT_LUXON_DATE_FORMATS} from '@angular/material-luxon-adapter'
import {MAT_DATE_FORMATS} from '@angular/material/core'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {provideRouter, withHashLocation} from '@angular/router'
import {
  authInterceptor,
  ConfigService,
  IConfig,
  responseInterceptor,
  SPB_LOGIN_SETTINGS,
  SPS_CONFIG,
  SPS_STORAGE
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {environment} from '../environments/environment'

import routes from './app-routes'
import {ADMIN_HOOK_ROLE, ADMIN_ROLE, ADMIN_START_PATH} from './application/types'

const configServiceConfig: IConfig = {
  authServiceUrl: environment.authServiceUrl,
  domain: environment.domain,
  adminRoles: [ADMIN_ROLE, ADMIN_HOOK_ROLE]
}

export const appConfig: ApplicationConfig = {
  providers: [
    {provide: SPS_CONFIG, useValue: configServiceConfig},
    {
      provide: SPB_LOGIN_SETTINGS, useValue: {
        title: 'Välkommen',
        text: 'För att komma igång behöver du logga in med BankID',
        buttonText: 'Logga in med BankID',
        route: ADMIN_START_PATH
      }
    },
    provideAppInitializer(() =>
      inject(ConfigService).bootstrap()),
    provideRouter(routes,
      withHashLocation()),
    provideHttpClient(withInterceptors([authInterceptor, responseInterceptor])),
    {provide: LOCALE_ID, useValue: 'sv-SE'},
    {provide: SPS_STORAGE, useValue: localStorage},
    {
      provide: MAT_LUXON_DATE_ADAPTER_OPTIONS,
      useValue: {useUtc: true, firstDayOfWeek: 1}
    },
    {provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS},
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
        subscriptSizing: 'dynamic',
        hideRequiredMarker: true,
        appearance: 'outline',
        floatLabel: 'always'
      }
    }
  ]
}
